// @flow
import {
    ADD_EVENT,
    ADD_SCHEDULE_DATA,
    ATTEMPT_SAVE_SCHEDULE,
    CANCEL_SAVE_SCHEDULE,
    CHANGE_MODE,
    COMPLETE_SAVE_SCHEDULE,
    COPY_DAY_EVENTS,
    DELETE_EVENT,
    DESELECT_SCHEDULE_DAY,
    HIDE_POPUP,
    OVERRIDE_SCHEDULE,
    RESET_SCHEDULE,
    SELECT_DAY,
    SELECT_EVENT,
    SETUP_ACTION_FORM_SCHEDULE,
    SHOW_POPUP,
    UNDO_ALL,
    UPDATE_EVENT_START,
    UPDATE_EVENT_VALUE,
    UPDATE_DAILY_START_TIMES
} from './constants';

import { createAction } from 'redux-actions';

export const addEvent = createAction(ADD_EVENT);
export const addScheduleData = createAction(ADD_SCHEDULE_DATA);
export const attemptSaveSchedule = createAction(ATTEMPT_SAVE_SCHEDULE);
export const cancelSaveSchedule = createAction(CANCEL_SAVE_SCHEDULE);
export const changeMode = createAction(CHANGE_MODE);
export const deselectScheduleDay = createAction(DESELECT_SCHEDULE_DAY);
export const completeSaveSchedule = createAction(COMPLETE_SAVE_SCHEDULE);
export const copyDayEvents = createAction(COPY_DAY_EVENTS);
export const deleteEvent = createAction(DELETE_EVENT);
export const hidePopup = createAction(HIDE_POPUP);
export const overrideSchedule = createAction(OVERRIDE_SCHEDULE);
export const resetSchedule = createAction(RESET_SCHEDULE);
export const selectDay = createAction(SELECT_DAY);
export const selectEvent = createAction(SELECT_EVENT);
export const setupActionFormSchedule = createAction(SETUP_ACTION_FORM_SCHEDULE);
export const showPopup = createAction(SHOW_POPUP);
export const undoAll = createAction(UNDO_ALL);
export const updateEventStart = createAction(UPDATE_EVENT_START);
export const updateEventValue = createAction(UPDATE_EVENT_VALUE);
export const updateDailyStartTimes = createAction(UPDATE_DAILY_START_TIMES);



// WEBPACK FOOTER //
// ./src/core/state/ui/schedule/actions.js